import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['currentUser']),

    currentExpertName() {
      return `${this.currentUser.firstName} ${this.currentUser.lastName}`;
    },
  },

  methods: {
    expertName({ firstName, lastName }) {
      const expertName = `${firstName} ${lastName}`;
      if (expertName === this.currentExpertName) return this.$t('self');

      return expertName;
    },
  },
};
